import Link from 'next/link'

import { ArticleUiIcon } from '@/components/icons/article-ui-icon'
import { domainOf } from '@/lib/analytics/link-utils'

import type { ListicleCardProps } from './types'

export const ListicleCardCta = ({ card, text }: ListicleCardProps) => {
  const { affiliateUrl, productUrl, index } = card
  return (
    <div className="mt-6">
      {affiliateUrl ? (
        <a
          href={affiliateUrl}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="group/btn bg-navy hover:bg-navy-90 flex w-full items-center justify-center gap-2 rounded-lg py-3.5 text-sm font-bold text-white shadow-md transition-all"
          data-track
          data-track-impression
          data-event-name="AffiliateAction"
          // No baked offer (earplugs, phones, manufacturer-direct pages —
          // products with no row in the offer tables) means no seller name.
          // Fall back to the destination host, which is what the old app
          // recorded for exactly these links ('beltone.com',
          // 'us.loopearplugs.com') and what the affiliate dashboard's
          // seller→partner map already keys on.
          data-event-seller={card.resolvedSellerName ?? domainOf(affiliateUrl)}
          data-affiliate-seller-type={card.resolvedSellerType ?? 'affiliate'}
          data-event-product={card.resolvedReleaseSlug ?? undefined}
          data-event-position={`listicle-item-${index}`}
          data-affiliate-cta="View Details"
          data-affiliate-text="View Details"
          data-affiliate-test-name="listicle-item"
          data-event-url={affiliateUrl}
        >
          {text.viewDetails}
          <ArticleUiIcon
            id="arrow-right"
            viewBox="0 0 24 24"
            className="h-4 w-4 transition-transform group-hover/btn:translate-x-1"
          />
        </a>
      ) : productUrl ? (
        <Link
          href={productUrl}
          prefetch={false}
          data-tracking="ignore"
          className="group/btn bg-navy hover:bg-navy-90 flex w-full items-center justify-center gap-2 rounded-lg py-3.5 text-sm font-bold text-white shadow-md transition-all"
        >
          {text.viewDetails}
          <ArticleUiIcon
            id="arrow-right"
            viewBox="0 0 24 24"
            className="h-4 w-4 transition-transform group-hover/btn:translate-x-1"
          />
        </Link>
      ) : null}
    </div>
  )
}
